import React from 'react';
import PropTypes from 'prop-types';
import css from './UpcomingInstructions.css';

export default class UpcomingInstructions extends React.Component {
  render() {
    return (
      <div className={css['instructions-container']}>
        <div className="instructions">{this.props.instructions}</div>
      </div>
    );
  }
}

UpcomingInstructions.propTypes = {
  instructions: PropTypes.string
};
